var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72179 0.178297C5.87544 0.019995 6.12456 0.0199948 6.27821 0.178296L9.10186 3.08745C9.29392 3.28533 9.29392 3.60615 9.10186 3.80403C8.90979 4.0019 8.5984 4.0019 8.40634 3.80403L6.4918 1.83151V7.90466C6.4918 8.1845 6.27162 8.41136 6 8.41136C5.72838 8.41136 5.5082 8.1845 5.5082 7.90466V1.83151L3.59366 3.80403C3.4016 4.0019 3.09021 4.0019 2.89814 3.80403C2.70608 3.60615 2.70608 3.28533 2.89814 3.08745L5.72179 0.178297ZM0.491803 6.58725C0.763419 6.58725 0.983607 6.81411 0.983607 7.09395V10.3368C0.983607 10.7286 1.29187 11.0462 1.67213 11.0462H10.3279C10.7081 11.0462 11.0164 10.7286 11.0164 10.3368V7.09395C11.0164 6.81411 11.2366 6.58725 11.5082 6.58725C11.7798 6.58725 12 6.81411 12 7.09395V10.3368C12 11.2883 11.2514 12.0596 10.3279 12.0596H1.67213C0.748639 12.0596 0 11.2883 0 10.3368V7.09395C0 6.81411 0.220188 6.58725 0.491803 6.58725Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterShare);
export default __webpack_public_path__ + "static/media/twitterShare.a15fca50.svg";
export { ForwardRef as ReactComponent };